// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__1Fek6"};